/* eslint-disable react/prop-types */
import { Collapse, IconButton } from '@material-ui/core'
import { Add, ArrowDropDown, ArrowDropUp, Remove } from '@material-ui/icons'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Container from '../../components/layout_micro/container'
import faqsData from './faqsData'

const Body = styled.div`
  padding: 4em 0em;
`
const Title = styled.div`
  font-size: 3.2em;
  font-family: 'imlbold'; font-weight: bold;
  color: var(--first);
  margin-bottom: 1.1em;
  text-align: center;
  @media screen and (max-width:500px) {
    font-size: 2.5em;
  }
`
const QuestionContainer = styled.div`
  margin-bottom: 1.3em;
`
const QuestionTitle = styled.div`
  width: 80%;
  font-size: 1.3em;
  color: var(--second);
`
const CuestionTitleCOntainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`
const QuestionParagraph = styled.div`
  font-size: 1.2em;
  color: var(--first);
  line-height: 1.2em;
  span {
    font-family: 'imlbold'; font-weight: bold;
  }
  .hiperlink {
    color: var(--second)!important;
    font-weight: bold;
    text-decoration: none;
  }
`
const ArrowDropDownStyled = styled(ArrowDropDown)`
  color: var(--second);
  font-size: 2em!important;
`
const ButtonContainer = styled.div`
  margin-top: 2em;
  cursor: pointer;
  font-size: 1.2em;
  color: var(--first);
  font-family: 'imlbold'; font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`
const IconButtonStyled = styled(IconButton)`
  background-color: var(--second);
  margin-right: 1em;
  padding: 0px;
  color: #fff;
  :hover {
    background-color: var(--second);
  }
`

const Question = props => {
  const [active, setActive] = useState(false)

  // close when master is closed
  useEffect(() => {
    if (!props.isOpen) setActive(false)
  }, [props.isOpen])

  return (
    <QuestionContainer>
      <CuestionTitleCOntainer onClick={event => setActive(!active)} $active={active}>
        <QuestionTitle>
          {props.title}
        </QuestionTitle>
        {active && (<ArrowDropDownStyled as={ArrowDropUp} />)}
        {!active && (<ArrowDropDownStyled />)}
      </CuestionTitleCOntainer>

      {props.bodies.map((paragraph, index) => (
        <Collapse key={index} in={active}>
          <div style={{ marginTop: '.8em' }}>
            <QuestionParagraph dangerouslySetInnerHTML={{ __html: paragraph }} />
          </div>
        </Collapse>
      ))}

    </QuestionContainer>
  )
}

const Faqs = () => {
  const [renderCompete, setRenderComplete] = useState(false)
  const faqsDataFiltered = renderCompete ? faqsData : faqsData.slice(0, 5)

  return (
    <Container id='faqs'>
      <Body>
        <Title>
          Preguntas frecuentes
        </Title>
        {faqsDataFiltered.map((faq, index) => (<Question isOpen={renderCompete} key={index} {...faq} />))}
        {!renderCompete && (
          <ButtonContainer onClick={event => setRenderComplete(true)}>
            <IconButtonStyled size='small'><Add /></IconButtonStyled>
            Ver más preguntas frecuentes
          </ButtonContainer>
        )}
        {renderCompete && (
          <ButtonContainer onClick={event => setRenderComplete(false)}>
            <IconButtonStyled size='small'><Remove /></IconButtonStyled>
            Cerrar preguntas frecuentes
          </ButtonContainer>
        )}
      </Body>
    </Container>
  )
}

export default Faqs
